import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";

type Props = {
  className?: string;
  label?: string;
};

const Fieldset = ({ children, className }: PropsWithChildren<Props>) => (
  <fieldset
    className={clsx({
      [`${className ? className : ""}`]: className,
    })}
  >
    {children}
  </fieldset>
);

Fieldset.Legend = ({ children, label, className }: PropsWithChildren<Props>) => {
  return (
    <legend
      className={clsx({
        [`${className ? className : ""}`]: className,
      })}
    >
      {label && label}
      {children && children}
    </legend>
  );
};

export default Fieldset;
